import React, { useRef, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Slider from 'react-slick'

import withRootContext from 'context/withRootContextHOC'
import { useServiceScheduleContext, actionTypes } from '../../../context/serviceScheduleContext'
import { usePetAndServicesContext } from '../../../context/petAndServicesContext'

import PageContainer from 'src/components/pageContainer'
import { Radio } from 'src/components/forms'

import FormSteps from 'src/components/formSteps'
import SchedulingInfo from 'src/components/schedulingSteps/schedulingInfo'
import LastSchedulingsCarousel from 'src/components/lastSchedulingsCarousel'

import { getPetPhotoByType, getServiceIconByName, splitServiceName, focus } from 'src/utils'
import { PAGE_URL, isMobile, scrollTop } from 'utils'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import * as S from './styles'
import * as Gs from 'src/styles/global'

import MODAL from '../../../utils/modals'
import { assetPrefix } from '../../../config/env_config'
import WarningModal from '../../warningModal'

const PetAndServices = (props) => {
  const { context } = props

  // Adaptação as antigas funções
  const router = useRouter()
  const { state: schedulingState, dispatch, functions: schedulingFunctions } = useServiceScheduleContext()
  const { modal } = schedulingState
  const { functions } = usePetAndServicesContext()
  const {
    handleWarningModalClose
  } = schedulingFunctions

  const {
    serviceData,
    additionalServiceData,
    petsData,
    formList,
    scheduleBody,
    isAllAdditionalServicesSelected,
    obs
  } = schedulingState

  const {
    handleSelectedMyPet,
    handleUnselectPet,
    handleSelectedService,
    handleToggleAllAdditional,
    handleToggleAdditional,
    retrievePetsData,
    retrieveServiceData
  } = functions

  const [petsDataLoaded, setPetsDataLoaded] = useState(false)
  const [keyboardOpen, setKeyboardOpen] = useState(false)
  const [isBanhoHidratacaoSelected, setIsBanhoHidratacaoSelected] = useState(false)

  // busca os pets
  const handleRetrieveData = async () => {
    await retrievePetsData({ context })
    setPetsDataLoaded(true)
  }

  useEffect(() => {
    handleRetrieveData()
  }, [])

  useEffect(() => {
    if (context.firstName) {
      handleRetrieveData()
      setPetsDataLoaded(false)
    }
  }, [context.firstName])

  // busca os serviços
  useEffect(() => {
    const retrieveData = async () => {
      if (!schedulingState?.serviceData?.length && router.query.category) {
        window.localStorage.setItem('category', router.query.category)
        await retrieveServiceData({ context, router })
      }
    }

    retrieveData()
  }, [router])

  useEffect(() => {
    const selected = serviceData.find(service => service.value === scheduleBody.service_id)
    setIsBanhoHidratacaoSelected(selected?.name === 'Banho&Hidratação')
  }, [scheduleBody.service_id, serviceData])

  const LOGGED_IN = context.firstName

  const queryCategory = router?.query?.category

  const selectedPet = petsData?.find(pet => pet.id === scheduleBody.pet_id)

  const inputRef = useRef(null)

  const additionalServicesRef = useRef(null)

  const onUpdateScheduling = (value) => { dispatch({ type: actionTypes.UPDATE_STATE, payload: value }) }

  const redirectToPetProfile = (query) => {
    router.push({
      pathname: PAGE_URL.PET_PROFILE,
      query
    })
  }

  const handleInputFocus = () => {
    if (isMobile()) { setKeyboardOpen(true) }
    focus(inputRef)
  }

  const handleInputBlur = () => {
    if (isMobile()) { setKeyboardOpen(false) }
  }

  const handleNewPet = () => {
    const query = {
      redirectTo: `${PAGE_URL.SCHEDULING_PET_AND_SERVICES}?category=${queryCategory}`
    }

    if (scheduleBody.partner_id) {
      return dispatch({
        type: actionTypes.UPDATE_STATE,
        payload: {
          modal: MODAL.NEW_PET_WARNING(() => {
            handleWarningModalClose()
            redirectToPetProfile(query)
          })
        }
      })
    }

    redirectToPetProfile(query)
  }

  const handleObsChange = (input) => {
    if (input.target.value.length <= 255) {
      onUpdateScheduling({
        obs: input.target.value
      })
    }
  }

  const handleSelectOrUnselectPet = (pet) => {
    if (selectedPet?.id !== pet.id) {
      handleSelectedMyPet(pet, { context })
      scrollTop()
    } else {
      handleUnselectPet()
    }
  }

  const showSchedulingInfo = () => {
    return scheduleBody.pet_id !== undefined && !keyboardOpen
  }

  const openAuthModal = () => context.toggleModalSheet(MODAL.LOGIN_MODAL({ onCancel: context.toggleModalSheet, callback: context.toggleModalSheet }))

  const slickOptions = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    pauseOnFocus: true,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    autoplay: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  }

  function getPetsCard () {
    if (petsData && petsData.length > 0) {
      return petsData.map((pet) => {
        // Se o cliente está agendando para mais de 1 pet, verifica se já foi marcado um serviço para o pet e desabilita a seleção do mesmo
        const showPet = !formList.length || formList.every(form => form.body.pet_id !== pet.id)
        const selected = selectedPet?.id === pet.id
        return (
          <div key={pet.id}>
            <S.Pet
              selected={selected}
              active={showPet}
              onClick={() => handleSelectOrUnselectPet(pet)}
            >
              <S.WrapperPetPhoto>
                <S.Photo
                  src={pet.photo || getPetPhotoByType(pet?.breed?.type)}
                  setDefaultPhoto={!pet.photo}
                  size='64px'
                  mobileSize='64px'
                />
                <S.TextInfo>
                  <span>{pet.name}</span>
                  <span>{pet?.breed?.name}</span>
                </S.TextInfo>
              </S.WrapperPetPhoto>
            </S.Pet>
          </div>
        )
      })
    }
    return null
  }

  return (
    <PageContainer isSchedulingSteps>
      <FormSteps context={context}>
        <S.PageContainer>

          {(!formList.length && petsData?.length > 0) && <LastSchedulingsCarousel category={queryCategory} petsData={petsData} />}

          <Gs.WrapperFormAndCard hasFormList={!!formList.length}>
            <S.WrapperForm>
              {/* Seleção de pets */}
              {(!selectedPet) &&
                <S.AlignWrappers paddingBottom={!(selectedPet && serviceData)}>
                  <S.WrapperTitle isPet>
                    <span>Selecione o pet</span>
                  </S.WrapperTitle>

                  {petsData.length > 3 ? (
                    <S.SliderContainer>
                      <Slider {...slickOptions}>
                        {getPetsCard()}
                      </Slider>
                    </S.SliderContainer>
                  ) : (
                    <S.WrapperElements>
                      {getPetsCard()}
                    </S.WrapperElements>
                  )}

                  {(petsData.length <= 0) &&
                    <S.NoPetData>
                      {(petsDataLoaded && !LOGGED_IN) &&
                        <S.UseExistingPet onClick={() => openAuthModal()}>
                          <S.Photo src={`${assetPrefix}/static/icons/dog-foot-print.svg`} />
                          Usar pet cadastrado
                        </S.UseExistingPet>}

                      {(petsDataLoaded && LOGGED_IN) &&
                        <S.PetNotFound>
                          <S.Photo mobileSize='64px' src={`${assetPrefix}/static/icons/search-icon-blue.svg`} />
                          <S.PetNotFoundTitle>Nenhum pet cadastrado</S.PetNotFoundTitle>
                          <S.PetNotFoundTextInfo>
                            Não encontramos nenhum pet cadastrado. Clique no botão abaixo e cadastre seu pet.
                          </S.PetNotFoundTextInfo>
                        </S.PetNotFound>}

                      {(!petsDataLoaded) &&
                        <S.PetNotFound>
                          <S.Photo mobileSize='64px' src={`${assetPrefix}/static/icons/search-icon-blue.svg`} />
                          <S.PetNotFoundTitle>Estamos buscando seu pet</S.PetNotFoundTitle>
                        </S.PetNotFound>}
                    </S.NoPetData>}

                  <S.PetRegistration onClick={() => handleNewPet()}>
                    Cadastrar novo pet
                  </S.PetRegistration>
                </S.AlignWrappers>}

              {/* Seleção de serviços */}
              {(selectedPet && serviceData) &&
                <S.AlignWrappers paddingBottom>
                  <S.WrapperTitle isService>
                    <span>Selecione o serviço</span>
                  </S.WrapperTitle>

                  <S.WrapperElements>
                    <S.WrapperServices>
                      {serviceData.map((service, index) => {
                        const isServiceSelected = service.value === scheduleBody.service_id
                        return (
                          <S.ServiceCard
                            key={service?.value || index}
                            active
                            onClick={() => handleSelectedService(
                              service.value,
                              additionalServiceData?.length > 0
                                ? additionalServicesRef
                                : inputRef,
                              { router, context, serviceName: splitServiceName(service.name) }
                            )}
                            selected={isServiceSelected}
                          >
                            <S.Container>
                              <S.Photo size='64px' noBorder src={getServiceIconByName(service.name)} />
                              <S.TextInfo isService>
                                <span>{splitServiceName(service.name)}</span>
                              </S.TextInfo>
                            </S.Container>
                            <S.ServiceOption>
                              <Radio name='service' defaultChecked={isServiceSelected} />
                            </S.ServiceOption>
                          </S.ServiceCard>
                        )
                      })}
                    </S.WrapperServices>

                    <S.WrapperAdditionalServicesAndObs>
                      {/* Seleção de serviços adicionais */}
                      {(!isMobile() ? additionalServiceData?.length > 0 && selectedPet : additionalServiceData?.length > 0 && selectedPet) &&
                        <S.WrapperAdditionalServices ref={additionalServicesRef}>
                          <S.WrapperTitle isServices>
                            <span>Escolha serviços adicionais (opcionais)</span>
                          </S.WrapperTitle>

                          <S.WrapperAdditionalServices>
                            <S.CheckList>
                              {
                                additionalServiceData.map(service => {
                                  const isHidratacao = service.name === 'Hidratação'
                                  const isChecked = scheduleBody.additional_services.includes(service.value)

                                  if (isBanhoHidratacaoSelected && isHidratacao) {
                                    if (isChecked) handleToggleAdditional(service.value, { router, context })
                                    return
                                  }

                                  return (
                                    <S.AdditionalServices key={service.id} active selected={isChecked} isChecked={isChecked} onClick={() => handleToggleAdditional(service.value, { router, context })}>
                                      <S.Photo size='24px' mobileSize='24px' src={getServiceIconByName(service.name)} borderRadiusNone />
                                      <label>{service.name}</label>
                                    </S.AdditionalServices>
                                  )
                                })
                              }

                              {!isBanhoHidratacaoSelected && <S.AdditionalServices active selected={isAllAdditionalServicesSelected} isChecked={isAllAdditionalServicesSelected} onClick={() => handleToggleAllAdditional(inputRef, { router, context })}>
                                <S.Photo size='24px' mobileSize='24px' src={getServiceIconByName('Todos')} borderRadiusNone />
                                <label>Todos os serviços</label>
                              </S.AdditionalServices>}
                            </S.CheckList>
                          </S.WrapperAdditionalServices>

                        </S.WrapperAdditionalServices>}

                      {/* Observação */}
                      {selectedPet &&
                        <S.TextareaContainer ref={inputRef}>
                          <S.WrapperTitle isServices>
                            <span>Observações (opcional)</span>
                          </S.WrapperTitle>
                          <label>
                            Observações
                          </label>
                          <S.ObsTextArea
                            placeholder='Escreva aqui alguma informação importante sobre o serviço ou seu pet.'
                            onChange={handleObsChange}
                            value={obs}
                            maxLength={255}
                            data-test='textarea-obs'
                            onFocus={handleInputFocus}
                            onBlur={handleInputBlur}
                          />
                          <S.Counter>
                            {obs.length}/255
                          </S.Counter>
                        </S.TextareaContainer>}
                    </S.WrapperAdditionalServicesAndObs>
                  </S.WrapperElements>
                </S.AlignWrappers>}
            </S.WrapperForm>

            {showSchedulingInfo() && (
              <SchedulingInfo />
            )}

          </Gs.WrapperFormAndCard>
        </S.PageContainer>
      </FormSteps>

      <WarningModal
        visible={!!modal}
        cancelLabel={modal?.cancelLabel}
        confirmLabel={modal?.confirmLabel}
        type={modal?.type}
        title={modal?.title}
        subtitle={modal?.subtitle}
        onConfirm={modal?.onConfirm}
        onCancel={handleWarningModalClose}
        fullButton={modal?.fullButton}
        outlineCancelButton={modal?.outlineCancelButton}
        showClose={modal?.showClose}
        icon={modal?.icon ? modal?.icon : !modal?.professional ? `${assetPrefix}/static/icons/warning.svg` : ''}
        iconSize={modal?.iconSize}
        overflow={modal?.overflow}
        dataTest='modal-warning-scheduling'
      >
        {modal?.body}
      </WarningModal>

    </PageContainer>
  )
}

export default withRootContext(PetAndServices)
